'use client';
import AboutSection from '../components/AboutSection';
import React, { useEffect, useRef } from 'react';
import AppImage from '@/components/ui/AppImage';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const team = [
  {
    name: 'Miko',
    role: 'CEO / Founder',
    image: '/assets/images/team/miko_magicstudio_oeotu7evxlq2.png',
    desc: 'Memimpin visi dan strategi perusahaan dalam mengembangkan ekosistem pertanian cerdas berbasis IoT di Kalimantan.',
  },
  {
    name: 'Pujo',
    role: 'COO',
    image: '/assets/images/team/pujo.png',
    desc: 'Mengelola operasional harian, koordinasi tim, dan kemitraan strategis.',
  },
  {
    name: 'Dani',
    role: 'CTO',
    image: '/assets/images/team/dani2.png',
    desc: 'Memimpin pengembangan teknologi IoT, platform SaaS, dan sistem monitoring real-time untuk pertanian modern.',
  },
];

const milestones = [
  { year: '2025', event: 'Agro Teknologi Nusantara didirikan di Kalimantan Timur' },
  { year: '2025', event: 'Pelatihan Smart Farming pertama untuk penyuluh swadaya Kukar' },
  { year: '2025', event: 'Penerimaan 14 peserta magang Smart Farming dari BPVP Samarinda' },
  { year: '2025', event: 'Workshop RFID 2025 diikuti oleh tim riset Agro Teknologi Nusantara' },
  { year: '2025', event: 'Dukungan peternak millennial dan program ketahanan pangan' },
  { year: '2025', event: 'Terima bantuan Program PKT 2025 dari DPPKUKM Kalimantan Timur' },
];

export default function TentangPage() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    const els = sectionRef?.current?.querySelectorAll('.reveal, .reveal-left, .reveal-right');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <main className="bg-canopy min-h-screen" ref={sectionRef}>
      <Header />

      <AboutSection />

      <div className="pt-32 pb-20">
        {/* Hero */}
        {/* <div className="bg-canopy blueprint-grid py-20 px-6 md:px-10 relative">
          <div className="max-w-7xl mx-auto">
            <div className="reveal flex items-center gap-4 mb-6">
              <div className="w-12 h-px bg-chartreuse opacity-60" />
              <span className="annotation">TENTANG KAMI · SEJAK 2024</span>
            </div>
            <h1 className="reveal delay-100 font-mono font-black text-5xl md:text-7xl text-text-primary leading-none tracking-tight mb-8">
              AGRO 
              <span className="text-chartreuse"> TEKNOLOGI </span>
               NUSANTARA
            </h1>
            <p className="reveal delay-200 text-text-muted text-xl max-w-3xl leading-relaxed">
              Perusahaan yang bergerak di bidang pertanian modern, hadir untuk
                membantu petani, pelaku usaha, dan komunitas agrikultur. Mengembangkan sistem
                pertanian yang lebih produktif, dan cerdas.
            </p>
          </div>
          <div className="absolute bottom-0 left-0 right-0 rule-line" />
        </div> */}

        {/* Company story */}
        {/* <div className="bg-pond blueprint-grid py-20 px-6 md:px-10">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
              <div className="reveal">
                <h2 className="font-mono font-bold text-3xl text-text-primary mb-6">
                  Cer Kami
                </h2>
                <div className="space-y-5">
                  <p className="text-text-muted text-base leading-relaxed">
                    Kami adalah perusahaan yang bergerak di bidang pertanian modern, hadir untuk
                    membantu petani, pelaku usaha, dan komunitas agrikultur mengembangkan sistem
                    pertanian yang lebih produktif, berkelanjutan, dan cerdas.
                  </p>
                  <p className="text-text-muted text-base leading-relaxed">
                    Kami memadukan pertanian dengan <span className="text-chartreuse font-mono">Internet of Things (IoT)</span>,
                    sistem monitoring real-time, dan pelatihan berkelanjutan. Dengan semangat
                    <span className="text-chartreuse font-mono"> Inovasi</span>,
                    <span className="text-chartreuse font-mono"> Solusi</span>, dan
                    <span className="text-chartreuse font-mono"> Kreasi</span>,
                    Agro Teknologi Nusantara tidak hanya menjual perangkat, tetapi juga membangun platform terintegrasi
                    yang dapat dimanfaatkan oleh petani, lembaga pendidikan, serta komunitas pengembang
                    di sektor agrikultur.
                  </p>
                  <p className="text-text-muted text-base leading-relaxed">
                    Berlokasi di Kalimantan Timur, kami aktif bekerja sama dengan pemerintah daerah,
                    BPVP Samarinda, DPPKUKM, dan berbagai komunitas pertanian untuk mendorong
                    adopsi teknologi pertanian cerdas di seluruh wilayah.
                  </p>
                </div>
              </div>

              <div className="reveal delay-200">
                {/* Vision */}
                {/* <div className="border border-chartreuse/20 rounded-sm p-8 bg-canopy/40 mb-6 relative">
                  <div className="absolute top-0 right-0 w-4 h-4 border-t border-r border-chartreuse/30" />
                  <div className="annotation mb-4">VISI</div>
                  <blockquote className="font-mono text-text-primary text-lg leading-relaxed">
                    Menjadi pelopor teknologi pertanian berbasis IoT dan edukasi digital di Kalimantan
                    yang berdampak nyata bagi petani dan generasi teknologi masa depan.
                  </blockquote>
                </div> */}

                {/* Values */}
              

        {/* Misi */}
        {/* <div className="bg-canopy blueprint-grid py-20 px-6 md:px-10">
          <div className="max-w-7xl mx-auto">
            <div className="reveal flex items-center gap-4 mb-8">
              <div className="w-12 h-px bg-chartreuse opacity-60" />
              <span className="annotation">MISI</span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                'Mengintegrasikan 500+ titik pertanian mengolah data untuk keperluan forecasting, analysis, dan penelitian untuk kepentingan bersama',
                'Meningkatkan produktivitas pertanian melalui teknologi monitoring dan otomatisasi',
                'Membangun komunitas pengembang IoT pertanian berbasis pembelajaran terbuka (LMS)',
                'Menyediakan platform SaaS untuk integrasi dan pengelolaan sistem pertanian cerdas',
              ].map((mission, i) => (
                <div key={i} className="reveal delay-100 border border-chartreuse/15 rounded-sm p-6 bg-pond/30 flex items-start gap-4">
                  <span className="font-mono font-black text-chartreuse text-2xl shrink-0">{String(i + 1).padStart(2, '0')}</span>
                  <p className="text-text-muted text-sm leading-relaxed">{mission}</p>
                </div>
              ))}
            </div>
          </div>
        </div> */}

        {/* Timeline */}
        {/* <div className="bg-pond blueprint-grid py-20 px-6 md:px-10">
          <div className="max-w-7xl mx-auto">
            <div className="reveal flex items-center gap-4 mb-8">
              <div className="w-12 h-px bg-chartreuse opacity-60" />
              <span className="annotation">MITAKAHIRAN · 2025</span>
            </div>
            <h2 className="reveal delay-100 font-mono font-bold text-3xl text-text-primary mb-10">
              Perjalanan Kami
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {milestones.map((m, i) => (
                <div key={i} className="reveal delay-100 border border-chartreuse/10 rounded-sm p-5 bg-canopy/30 hover:border-chartreuse/25 transition-colors">
                  <div className="font-mono font-bold text-chartreuse text-lg mb-2">{m.year}</div>
                  <p className="text-text-muted text-sm leading-relaxed">{m.event}</p>
                </div>
              ))}
            </div>
          </div>
        </div> */}

        {/* Team */}
        <div className="bg-canopy blueprint-grid  px-6 md:px-10">
          <div className="max-w-7xl mx-auto">
            <div className="reveal flex items-center gap-4 mb-8">
              <div className="w-12 h-px bg-chartreuse opacity-60" />
              <span className="annotation">TIM KAMI</span>
            </div>
            <h2 className="reveal delay-100 font-mono font-bold text-3xl text-text-primary mb-10">
              Di Balik Agro Teknologi Nusantara
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {team.map((member, i) => (
                <div key={member.name} className={`reveal delay-${(i + 1) * 100} text-center`}>
                  <div className="relative w-48 h-48 mx-auto mb-6 overflow-hidden border border-chartreuse/20">
                    <img
                      src={member.image}
                      alt={`Foto ${member.name} - ${member.role}`}
                      className="w-full h-full object-cover object-top"
                      onError={(e) => {
                        e.currentTarget.style.display = 'none';
                      }}
                      style={{ filter: 'opacity(0.9)' }}
                    />
                  </div>
                  <h3 className="font-mono text-text-primary text-xl mb-1">{member.name}</h3>
                  <div className="font-mono font-bold text-chartreuse text-xs tracking-widest mb-3">{member.role}</div>
                  <p className="text-text-muted text-sm leading-relaxed">{member.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="bg-pond blueprint-grid py-16 px-6 md:px-10">
          <div className="max-w-7xl mx-auto text-center">
            <p className="reveal text-text-muted text-lg mb-6">
              Tertarik bekerja sama dengan Agro Teknologi Nusantara?
            </p>
            <div className="reveal delay-100 flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/quote"
                className="btn-chartreuse px-8 py-4 rounded-sm text-sm uppercase tracking-widest inline-block"
              >
                Hubungi Kami →
              </a>
              <a
                href="/"
                className="btn-outline-chartreuse px-8 py-4 rounded-sm text-sm uppercase tracking-widest inline-block"
              >
                Lihat Layanan
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </main>
  );
}
